import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-139d1332"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "training-container"
}

import { ref } from "vue";
import { Training } from "@/types/training/Training";
import { useModal } from "@/utils/modal";
import { trainingService } from "@/app/services/TrainingService";
import { useLoader } from "@/utils/loader";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { onMounted } from "vue";
import { useCustomRouter } from "@/utils/router";
import Cover from "./organisms/Cover.vue";
import Question from "./organisms/Question.vue";
import { applicationService } from "@/app/services/ApplicationService";


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const customRouter = useCustomRouter();
const route = useRoute();
const modal = useModal();
const loader = useLoader();
const training = ref<Training | null>(null);
const trainingStarted = ref(false);
const trainingId = computed((): string => {
  return route.params.trainingId as string;
});
const applicationId = computed((): number => {
  return Number(route.query.applicationId);
});

onMounted(() => {
  loadTraining();
});

async function loadTraining() {
  try {
    loader.show();
    training.value = (
      await trainingService.fetchTraining(trainingId.value)
    ).body;
  } catch (e) {
    await modal.msgBoxOk("トレーニングの取得に失敗しました。", {
      centered: true
    });
  } finally {
    loader.hide();
  }
}

async function onTrainingFinished() {
  try {
    loader.show();
    const application = await applicationService.fetchApplication(
      applicationId.value
    );
    if (!application) {
      await modal.msgBoxOk("応募情報の取得に失敗しました。", {
        centered: true
      });
      return;
    }
    await trainingService.finishTraining(
      trainingId.value,
      application.order.office.id
    );
    await customRouter.pushIgnoreError({
      name: "WorkStarted",
      params: { applicationId: applicationId.value.toString() }
    });
  } catch (e) {
    await modal.msgBoxOk("回答の登録に失敗しました。", {
      centered: true
    });
  } finally {
    loader.hide();
  }
}

function onClickStart() {
  trainingStarted.value = true;
}

return (_ctx: any,_cache: any) => {
  return (training.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (trainingStarted.value)
            ? (_openBlock(), _createBlock(Question, {
                key: 0,
                training: training.value,
                onFinish: onTrainingFinished
              }, null, 8, ["training"]))
            : (_openBlock(), _createBlock(Cover, {
                key: 1,
                training: training.value,
                onStart: onClickStart
              }, null, 8, ["training"]))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})